import "swiper";
import Cash from "cash-dom";
import {
    mergeSettings,
    writeNavigationButtons,
    writePagination
} from "./Functions";
import { interLeaveEffect } from "./InterLeaveEffect";

const isLive = document.documentElement.classList.contains("-live");

let type = {
    openingTimes(slider, settings, nummberOfSlides) {
        let options = mergeSettings({
            typeSettings: {
                spaceBetween: 20,
                slidesOffsetBefore: 10,
                slidesOffsetAfter: 20,
                slidesPerView: 6,
                breakpoints: {
                    // when window width is <= 320px
                    767: {
                        slidesPerView: 1.5
                    },
                    991: {
                        slidesPerView: 2.5
                    },
                    1919: {
                        slidesPerView: 3.5
                    }
                }
            },
            settings,
            nummberOfSlides
        });

        new Swiper(slider, options);
    },
    image(slider, settings, nummberOfSlides) {
        if (isLive) {
            Cash.extend(settings, interLeaveEffect(-0.5));
        }

        let buttons = writeNavigationButtons({ slider });
        let options = mergeSettings({
            typeSettings: {
                nextButton: nummberOfSlides > 1 ? buttons.next : false,
                prevButton: nummberOfSlides > 1 ? buttons.prev : false,
                autoplay: isLive && nummberOfSlides > 1 ? 4000 : false,
                onReachEnd: swiper => {
                    swiper.stopAutoplay();
                },
                loop: true,
                speed: 1500,
                spaceBetween: 0,
                //grabCursor: nummberOfSlides > 1 && isLive ? true : false,
                watchSlidesProgress: true,
                preloadImages: false,
                lazyLoading: true,
                lazyLoadingInPrevNext: true,
                simulateTouch: false
            },
            settings,
            nummberOfSlides
        });
        new Swiper(slider, options);
    }
};

export { type };
